import NotFonudLayout from './layout';

export default [
    {
        path: '*',
        component: NotFonudLayout,
    },
];
